import {
  getReflectionTemplateByIdUrl,
  getReflectionTemplatesUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class ReflectionTemplateService {
  static getTemplates = () => {
    return getRequest(getReflectionTemplatesUrl());
  };

  static createTemplate = (template) => {
    return postRequest(getReflectionTemplatesUrl(), template);
  };

  static updateTemplate = (template) => {
    return putRequest(getReflectionTemplateByIdUrl(template.id), template);
  };

  static deleteTemplate = (templateId) => {
    return deleteRequest(getReflectionTemplateByIdUrl(templateId));
  };
}
